import { NumberingCharacterTypes } from '@src/slide/domain/ui-model/element-modeles/property/text/constants/character-type';
import { getConvertAutoNumCharacterText } from '@src/slide/domain/ui-model/element-modeles/property/text/utils/character-utils/auto-num-type';
import { replaceAll } from '@src/slide/infrastructure/module/independent/string';

type NumberingCharacterConfig = Array<{type: string; startText: string}>;

let numberingCharacterConfig: null | NumberingCharacterConfig = null;
/**
 * 获取数字编号的配置项，包含数字编号的type和起始文本
 * @returns { NumberingCharacterConfig }
 */
export function getNumberingCharacterConfig(): NumberingCharacterConfig {
    if (numberingCharacterConfig) {
        return numberingCharacterConfig;
    }
    numberingCharacterConfig = NumberingCharacterTypes.map(type => ({
        type,
        startText: replaceAll(getConvertAutoNumCharacterText({ type }) as string, '\u00a0', ''),
    }));
    return numberingCharacterConfig;
}
